import { ca } from '@cian/analytics';

type TPlaceType = 'main_label' | 'gallery';

export const trackCallbackWidgetOpen = (gaLabel: string, placeType: TPlaceType) => {
  const extra: Record<TPlaceType, boolean> = {
    main_label: false,
    gallery: false,
  };

  extra[placeType] = true;

  ca('eventSite', {
    name: 'oldevent',
    action: 'Booking_click_label',
    category: 'Card',
    label: gaLabel,
    useLastProducts: true,
    page: {
      extra,
    },
  });
};
